import { passwordStrength } from "../lib/password";

/**
 * BD1 — four-band strength meter under create-password inputs.
 * Advisory UX only; the submit gate is passwordPolicyError (mirrors server).
 * Colors stay inside the brand system: ink tints for weak, brand green for
 * good/strong — no traffic-light red (calm, not alarming).
 */
export function PasswordStrengthMeter({ password }: { password: string }) {
  const { score, label } = passwordStrength(password);
  return (
    <div aria-live="polite">
      <div className="flex items-center gap-1.5" aria-hidden="true">
        {[1, 2, 3, 4].map((band) => (
          <span
            key={band}
            className="h-1 flex-1 rounded-full transition-colors duration-[var(--duration-base)]"
            style={{
              backgroundColor:
                score >= band
                  ? score <= 2
                    ? "var(--color-ink-40)"
                    : "var(--color-brand)"
                  : "var(--color-ink-16)",
            }}
          />
        ))}
      </div>
      <span className="mt-1 block min-h-[16px] text-[11.5px] text-[var(--color-ink-40)]">
        {label ? `Password strength: ${label}` : " "}
      </span>
    </div>
  );
}

export default PasswordStrengthMeter;
